<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.nodeTypeModule.detail')"
        @close="visible = false">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-input
                    v-model="dataEdit.name"
                    :label="$t('labels.nodeTypeModule.name')"
                    :color="props.color"
                    readonly />
                <hts-form-input
                    v-model="dataEdit.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description"
                    readonly />
                <hts-form-select
                    v-model="dataEdit.businesses"
                    :query="findBusinesses"
                    :filterable="true"
                    :clearable="true"
                    :label="$t('labels.business')"
                    multiple
                    key-id="_id"
                    key-label="name"
                    :selected-multiple="dataEdit?.businessSelected || []"
                    readonly />
            </div>
        </hts-card>
    </hts-drawer>
</template>
<script setup lang="ts">
import { INodeType } from '../imports/model'
import system from '~/composables/api-system-url/system'
import { $urlSystem } from '#imports'
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const dataEdit = ref<INodeType>({
  _id: '',
  code: '',
  name: '',
  businesses: [],
  businessSelected: []
})

const visible = ref(false)

const open = (idNodeType: string) => {
  visible.value = true
  if (!idNodeType) {
    return
  }
  const api = $urlSystem.node.type.getDetail
  $api(api, { uriParams: { ID: idNodeType } }).then((data) => {
    const resData: any = data?.data?.value
    if (resData.success) {
      resData.data.businessSelected = resData.data.businesses
      resData.data.businesses =
        resData.data.businesses.map((business: any) => {
          return business._id
        }) || []
      dataEdit.value = resData.data
    }
  })
}
defineExpose({
  open
})

const findBusinesses = async (s: string) => {
  const api = $urlSystem.business.select
  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}

const emits = defineEmits(['close', 'refreshTables', 'newBusiness', 'update:show'])

const closeOverSide = () => {
  emits('close')
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
